<tab-header [workPackage]="workPackage"></tab-header>
<tab-prs [workPackage]="workPackage"></tab-prs>
